import { createScreen } from "utils/createScreen";
import { AudienceCatalogScreen } from "../../../../types";

const CatalogManagerScreenDefinition = createScreen({
  name: AudienceCatalogScreen,
  path: "/audience-catalog",
  routePath: ["/"],
  accessPath: "audienceCatalog",
});

export { CatalogManagerScreenDefinition };
